<template>
  <div class="oral-examination" v-if="teeth.length > 0">
    <div class="oral-examination__row shadow">
      <examined-tooth
        v-bind:class="{ 'disable-component': disabled }"
        v-for="tooth in upper"
        v-bind:key="tooth.number"
        v-bind:diagnoses-list="diagnoses"
        v-bind:diagnosis-lower="tooth.lower"
        v-bind:diagnosis-upper="tooth.upper"
        v-on:change="dispatchToothChange(tooth.number, $event)"
      />
    </div>
    <div class="oral-examination__row">
      <div class="oral-examination__number" v-for="i in half" v-bind:key="i">
        {{ getToothIndex(i) }}
      </div>
    </div>
    <div class="oral-examination__row shadow">
      <examined-tooth
        v-bind:class="{ 'disable-component': disabled }"
        v-for="tooth in bottom"
        v-bind:key="tooth.number"
        v-bind:diagnoses-list="diagnoses"
        v-bind:diagnosis-lower="tooth.lower"
        v-bind:diagnosis-upper="tooth.upper"
        v-on:change="dispatchToothChange(tooth.number, $event)"
      />
    </div>
  </div>
</template>

<script>
import ExaminedTooth from './ExaminedTooth.vue';

/**
 * @description Компонент осмотра полости рта.
 */
export default {
  components: { ExaminedTooth },
  computed: {
    /**
     * @description Верхняя челюсть.
     * @type {any[]}
     */
    upper({ teeth, half }) {
      return teeth.slice(0, half);
    },
    /**
     * @description Нижняя челюсть.
     * @type {any[]}
     */
    bottom({ teeth, half }) {
      return teeth.slice(half, teeth.length);
    },
    /**
     * @description Половина от количества зубов.
     * @type {number}
     */
    half({ teeth }) {
      return teeth.length / 2;
    },
  },
  methods: {
    /**
     * @description Отправить событие изменения зуба.
     * @param {number} toothNumber Номер зуба.
     * @param {any}    diagnosis   Диагноз.
     */
    dispatchToothChange(toothNumber, diagnosis) {
      this.$emit('tooth-change', toothNumber, diagnosis);
    },
    /**
     * @description Получить позицию зуба.
     * @param {number} index
     * @returns {number}
     */
    getToothIndex(index) {
      const half = this.half / 2 + 1;
      if (index < half) {
        return half - index;
      }
      return index - half + 1;
    },
  },
  props: {
    /**
     * @description Диагнозы.
     * @type {any[]}
     */
    diagnoses: { type: Array, required: true },
    /**
     * @description Зубы.
     * @type {any[]}
     */
    teeth: { type: Array, default: () => [] },
    /**
     * @description Деактивировано.
     */
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.oral-examination {
  &__container {
    flex-direction: row;
    display: flex;
    gap: 32px;
    margin: 18px 0 0 0;
  }
  &__row {
    flex-direction: row;
    display: flex;
    width: fit-content;
    gap: 2px;
    &.shadow {
      box-shadow: 6px 0px 18px rgba(0, 0, 0, 0.06);
      background-color: #f2f5f8!important;
      filter: drop-shadow(6px 0px 18px rgba(0, 0, 0, 0.06));
    }
  }
  &__number {
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    font-weight: 300;
    font-size: 16px;
    line-height: 44px;
    text-align: center;
    border-radius: 3px;
  }
}
</style>
